export const LOGIN_METHOD = {
  PIN: 'PIN',
  QR: 'QR',
  NFC: 'NFC',
  RFID: 'RFID',
};
